import { createSlice } from '@reduxjs/toolkit';
import { IActivity } from '../../../../dto';
import { setActivity } from '../actions';
import { MN_ACTIVITIES, TYPE_ELEMENT } from '../../../../common';

export interface ActivityState {
  data: IActivity | null;
  loading: boolean;
  error: string | null;
}

const initialState: ActivityState = {
  data: null,
  loading: false,
  error: null,
};

export const activitySlice = createSlice({
  name: `${MN_ACTIVITIES}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setActivity, (state, { payload }) => {
      state.data = payload;
    });
  },
});
